var map = {
	"./de.json": 46341,
	"./en.json": 95817,
	"./es.json": 75322,
	"./fr.json": 10098,
	"./it.json": 23851,
	"./pt.json": 66470,
	"locales/de.json": 46341,
	"locales/en.json": 95817,
	"locales/es.json": 75322,
	"locales/fr.json": 10098,
	"locales/it.json": 23851,
	"locales/pt.json": 66470
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90589;